
import { defineComponent } from 'vue'
import { truncate } from '@/utilities/strings'

export default defineComponent({
  name: 'BaseCard',
  props: {
    fileName: { type: String, required: true },
  },
  setup(props) {
    const truncatedFileName = truncate(props.fileName, 35)

    return { truncatedFileName }
  },
})
